// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImljb24uY29tcG9uZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7SUFDSTtNQUNFLG9CQUFvQjtNQUNwQixtQkFBbUI7TUFDbkIsdUJBQXVCO0lBQ3pCIiwiZmlsZSI6Imljb24uY29tcG9uZW50LnRzIiwic291cmNlc0NvbnRlbnQiOlsiXG4gICAgOmhvc3Qge1xuICAgICAgZGlzcGxheTogaW5saW5lLWZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgfVxuICAiXX0= */`, "",{"version":3,"sources":["webpack://./packages/ng-shared-ui/src/lib/atoms/icon/icon.component.ts"],"names":[],"mappings":";IACI;MACE,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB;IACzB;;AAEJ,4aAA4a","sourcesContent":["\n    :host {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
